import { useGetAllDatasetDeliveryQuery } from '@verantos-dev/data-access-dataset-delivery';
import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useDatasetDeliveryTable } from '../hooks/useDatasetDeliveryTable';

export const DataSetDeliveryTable: React.FC = () => {
  const { columns } = useDatasetDeliveryTable();
  const usePollAllDatasetDelivery = () => {
    return useGetAllDatasetDeliveryQuery('', { pollingInterval: 10000 });
  };
  return (
    <DataGridLayout id="dataset-delivery-datagrid-layout">
      <DataGrid
        id="dataset-delivery-list"
        mode="client"
        getRowId={(row) => row.dataset}
        columns={columns}
        useFetchDataGridData={usePollAllDatasetDelivery}
        getRowCount={(data) => data.pagination.total}
        pageSizeOptions={[10, 25, 50, 100]}
        initialPageSize={100}
        pagination
        disableColumnSelector
        disableColumnPinning
        initialState={{
          sorting: {
            sortModel: [{ field: 'name', sort: 'asc' }],
          },
        }}
      />
    </DataGridLayout>
  );
};
